import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { auth } from '../firebase';
import imageCompression from 'browser-image-compression';

import {
  ref,
  uploadBytes,
  getDownloadURL,
} from 'firebase/storage';

import {
  doc,
  updateDoc,
  arrayUnion,
} from 'firebase/firestore';

import { db, storage } from '../firebase';

const UploadPhotos = () => {

  const { id } = useParams();

  const [uploading, setUploading] = useState(false);

  const [uploadedPhotos, setUploadedPhotos] = useState([]);
  const [finalized, setFinalized] = useState(false);

  const handleUpload = async (e) => {

    const files = Array.from(e.target.files);

    if (!files.length) return;

    try {

      setUploading(true);

      const uploadedUrls = [];

      for (const file of files) {

        const fileName = `${Date.now()}-${file.name}`;

        const storageRef = ref(
          storage,
          `orders/${id}/${fileName}`
        );
        const compressedFile = await imageCompression(file, {
          maxSizeMB: 1,
          maxWidthOrHeight: 1600,
          useWebWorker: true,
        });
        await uploadBytes(storageRef, compressedFile);

        const downloadURL = await getDownloadURL(storageRef);

        uploadedUrls.push(downloadURL);

        await updateDoc(doc(db, 'Orders', id), {
          photos: arrayUnion(downloadURL),
          whoUploadedPhoto: auth.currentUser?.uid || '',
        });

      }

      setUploadedPhotos((prev) => [
        ...prev,
        ...uploadedUrls,
      ]);

    } catch (error) {

      console.log(error);

    } finally {

      setUploading(false);

    }

  };

  const finalizeOrder = async () => {
    try {
      await updateDoc(doc(db, 'Orders', id), {
        status: 'Active',
      });
      window.close();
    } catch (error) {
      console.log(error);
    }
  };

  const handleFinalizeOrder = async () => {
  try {
    await finalizeOrder(); // твоя функция смены статуса
    setFinalized(true);
  } catch (e) {
    console.error(e);
  }
};

  return (

    <div className="min-h-screen bg-[#1a3d1a] px-4 py-10 text-white">

      <div className="mx-auto max-w-[700px]">

        <div className="mb-8 text-center">

          <div
            className="mb-4 text-[12px] tracking-[3px] text-[#a8d8a8]"
            style={{
              fontFamily: "'Press Start 2P', monospace",
            }}
          >
            KOFFEr STORAGE
          </div>

          <h1
            className="text-3xl leading-relaxed text-[#4CAF50]"
            style={{
              fontFamily: "'Press Start 2P', monospace",
            }}
          >
            SUBIR
            <br />
            FOTOS
          </h1>

        </div>

        <div className="rounded-2xl border-4 border-[#4CAF50] bg-[#f5f0e8] p-6 shadow-[8px_8px_0px_#4CAF50]">

          <label
            className="flex min-h-[240px] cursor-pointer flex-col items-center justify-center border-[3px] border-dashed border-[#2f7d4f] bg-white text-center transition hover:bg-[#edf5ed]"
          >

            <div className="mb-4 text-6xl">
              📷
            </div>

            <div
              className="px-4 text-[10px] leading-7 text-[#2f7d4f]"
              style={{
                fontFamily: "'Press Start 2P', monospace",
              }}
            >
              TOCAR PARA
              <br />
              HACER FOTO
              <br />
              O SUBIR
              <br />
              IMAGENES
            </div>

            <input
              type="file"
              accept="image/*"
              // capture="environment"
              multiple
              onChange={handleUpload}
              className="hidden"
            />

          </label>

          {uploading && (

            <div
              className="mt-6 text-center text-[10px] text-[#2f7d4f]"
              style={{
                fontFamily: "'Press Start 2P', monospace",
              }}
            >
              SUBIENDO...
            </div>

          )}

          {uploadedPhotos.length > 0 && (

            <div className="mt-8 grid grid-cols-2 gap-4">

              {uploadedPhotos.map((photo, index) => (

                <img
                  key={index}
                  src={photo}
                  alt=""
                  className="aspect-square rounded-xl border-4 border-[#4CAF50] object-cover"
                />

              ))}

            </div>

          )}
          <button
            onClick={handleFinalizeOrder}
            disabled={uploading}
            className="
              mt-8
              w-full
              rounded-2xl
              bg-[#4CAF50]
              px-6
              py-5
              text-[12px]
              text-white
              shadow-[6px_6px_0px_#2f7d4f]
              transition
              hover:translate-x-[3px]
              hover:translate-y-[3px]
              hover:shadow-[3px_3px_0px_#2f7d4f]
              disabled:opacity-50
            "
            style={{
              fontFamily: "'Press Start 2P', monospace",
            }}
          >
            {finalized ? "Podés cerrar la ventana" : "FINALIZAR"}
          </button>
        </div>

      </div>

    </div>

  );

};

export default UploadPhotos;